import React, { useEffect, useMemo } from 'react';
import { EditRedistributionData } from '../editRedistributionLib';
import { useGetCalculationCategoryPairingsQuery } from '../../../Calculations/apiCalculationsCategories';
import { Row, Spinner } from '@ydistri/ds';
import { ROOT_CATEGORY_ID } from '../../../../components/global/_constants';
import { Operation } from '@ydistri/api-sdk';
import { useAppDispatch } from '../../../../store';
import { AvailableModals, openModal } from '../../../Modals/modalSlice';

type EditRedistributionProductProps = Pick<EditRedistributionData, 'calculationId' | 'productId'>;

/**
 * This is always just temporary modal.
 * In case of removing "Product" from redistribution, we want to:
 *  1. load its picking positions
 *  2. switch to "picking positions" modal
 * @param calculationId
 * @param productId
 * @constructor
 */
const EditRedistributionProduct: React.FC<EditRedistributionProductProps> = ({
  calculationId,
  productId,
}) => {
  const dispatch = useAppDispatch();

  const params = useMemo(
    () => ({
      calculationId,
      categoryId: ROOT_CATEGORY_ID,
      skip: 0,
      top: 0,
      conditions: [
        {
          fieldName: 'Product/Id',
          operation: Operation.Eq,
          value: productId,
        },
      ],
    }),
    [calculationId, productId],
  );

  const { data: redistributionData, isFetching } = useGetCalculationCategoryPairingsQuery(params);

  useEffect(() => {
    if (!redistributionData || isFetching) return;
    dispatch(
      openModal({
        type: AvailableModals.EDIT_REDISTRIBUTION,
        data: {
          modalTitle: `Remove picking positions of product "${redistributionData.data[0]?.product?.name}" from redistribution`,
          calculationId,
          pickingPositions: redistributionData.data,
          productId: undefined,
        },
      }),
    );
  }, [redistributionData, isFetching, dispatch, calculationId]);

  return (
    <Row>
      <Spinner /> Loading picking positions of a product...
    </Row>
  );
};

export default EditRedistributionProduct;
